// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19zc0","footer":"styles_footer__258pU","passCodeTooltip":"styles_passCodeTooltip__rsnXf"};